import { useCallback, useState } from "react";

// Components
import { Heading1, Paragraph } from "../components/typography";

// Containers
import RegisterStepOneForm from "../containers/forms/register/RegisterStepOne.form";
import RegisterStepTwoForm from "../containers/forms/register/RegisterStepTwo.form";

// Forms Models
import { RegisterAccountForm, BussinesForm } from "../models/app/forms";

const Register = () => {
  const [registerPageState, setRegisterPageState] = useState({
    accountForm: new RegisterAccountForm(),
    bussinessForm: new BussinesForm(),
    isStepOne: true
  });

  const handleBack = useCallback(step2FormData => {
    setRegisterPageState(prevState => ({
      ...prevState,
      bussinessForm: { ...prevState.bussinessForm, ...step2FormData },
      isStepOne: true
    }));
  }, []);

  const handleNext = useCallback(step1FormData => {
    setRegisterPageState(prevState => ({
      ...prevState,
      accountForm: { ...prevState.accountForm, ...step1FormData },
      isStepOne: false
    }));
  }, []);

  return (
    <>
      <Heading1 style={{ margin: "40px 0 8px 0", fontSize: 32 }}>
        {registerPageState.isStepOne
          ? "Create your account"
          : "Set up your business"}
      </Heading1>
      <Paragraph
        style={{ margin: "0 0 40px 0", color: "#8E8E8E", fontSize: 14 }}
      >
        {registerPageState.isStepOne
          ? "Get started with TruckFix ERP."
          : "Complete your business profile to continue."}
      </Paragraph>
      <div
        style={{ width: 390, maxWidth: "calc(100vw - 40px)", position: "relative" }}
      >
        {registerPageState.isStepOne ? (
          <RegisterStepOneForm
            handleNext={handleNext}
            accountForm={registerPageState.accountForm}
          />
        ) : (
          <RegisterStepTwoForm
            handleBack={handleBack}
            bussinessForm={registerPageState.bussinessForm}
            accountForm={registerPageState.accountForm}
          />
        )}
      </div>
    </>
  );
};

export default Register;
